<loader [position]="{ absolute: true }" [active]="!isVinInfo"></loader>
<main class="main wrapper__main report" *ngIf="vinInfo">
  <!-- <embed type="text/html" width="500" height="200" id="setbackgroundInfo" class="report__infobackground"> -->
  <section class="report__topheader">
    <div class="container">
      <div class="row mx-n2">
        <div class="col-12 px-2">
          <div class="report__header py-4 mb-3">
            <div class="report__logo mx-auto">
              <img src="assets/images/logo3.svg" width="200" class="logo" />
            </div>
          </div>
        </div>

        <div class="col-6 px-2">
          <div class="report__showcase_image">
            <img
              src="{{ mainImage ? mainImage : '/assets/images/na.png' }}"
              width="200"
              height="200"
            />
          </div>
        </div>

        <div class="col-6 px-2">
          <div class="report__itemCode mb-3">
            <h4 class="fs fs__md-high font-weight-bold text-center">
              {{ vinInfo['vehicle_item_code'] }}
            </h4>
          </div>
          <div class="report__ratingContainer">
            <div class="report__rating mr-3">
              <h4 class="fs fs__md font-weight-bold my-0">Calculated Value</h4>
              <div
                class="report__score my-3"
                [class.excellent]="calculatedScore >= 5"
                [class.good]="calculatedScore >= 4.5 && calculatedScore < 5"
                [class.v-fair]="calculatedScore >= 4 && calculatedScore <= 4.5"
                [class.fair]="calculatedScore >= 3.5 && calculatedScore <= 3.999"
                [class.avg]="calculatedScore >= 3 && calculatedScore <= 3.4"
                [class.b-avg]="calculatedScore >= 2.5 && calculatedScore <= 2.999"
                [class.poor]="calculatedScore >= 2 && calculatedScore <= 2.4"
                [class.v-poor]="calculatedScore >= 1.5 && calculatedScore <= 1.999"
                [class.junk]="calculatedScore >= 1 && calculatedScore <= 1.4"
              >
                {{ +calculatedScore > 5 ? '5.0' : (+calculatedScore | number: '0.1-1') }}
              </div>

              <p class="report__ratingTitle my-0">
                <ng-container *ngIf="calculatedScore >= 5">
                  {{ 'grading.excellent' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 4.5 && calculatedScore < 5">
                  {{ 'grading.good' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 4 && calculatedScore <= 4.5">
                  {{ 'grading.v_fair' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 3.5 && calculatedScore <= 3.999">
                  {{ 'grading.fair' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 3 && calculatedScore <= 3.5">
                  {{ 'grading.average' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 2.5 && calculatedScore <= 2.999">
                  {{ 'grading.below_average' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 2 && calculatedScore <= 2.4">
                  {{ 'grading.poor' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 1.5 && calculatedScore <= 1.999">
                  {{ 'grading.v_poor' | translate }}
                </ng-container>
                <ng-container *ngIf="calculatedScore >= 1 && calculatedScore <= 1.5">
                  {{ 'grading.junk' | translate }}
                </ng-container>
              </p>
            </div>

            <div class="report__rating">
              <h4 class="fs fs__md font-weight-bold my-0">Perceived Value</h4>

              <div
                class="report__score my-3"
                [class.excellent]="PerceivedScore >= 5"
                [class.good]="PerceivedScore >= 4.5 && PerceivedScore !== 5"
                [class.v-fair]="PerceivedScore >= 4 && PerceivedScore <= 4.5"
                [class.fair]="PerceivedScore >= 3.5 && PerceivedScore <= 3.999"
                [class.avg]="PerceivedScore >= 3 && PerceivedScore <= 3.4"
                [class.b-avg]="PerceivedScore >= 2.5 && PerceivedScore <= 2.999"
                [class.poor]="PerceivedScore >= 2 && PerceivedScore <= 2.4"
                [class.v-poor]="PerceivedScore >= 1.5 && PerceivedScore <= 1.999"
                [class.junk]="PerceivedScore >= 1 && PerceivedScore <= 1.4"
              >
                {{ +PerceivedScore ? PerceivedScore : 'N/A' }}
              </div>

              <p class="report__ratingTitle my-0">
                <ng-container *ngIf="PerceivedScore >= 5">
                  {{ 'grading.excellent' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 4.5 && PerceivedScore !== 5">
                  {{ 'grading.good' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 4 && PerceivedScore <= 4.5">
                  {{ 'grading.v_fair' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 3.5 && PerceivedScore <= 3.999">
                  {{ 'grading.fair' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 3 && PerceivedScore <= 3.5">
                  {{ 'grading.average' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 2.5 && PerceivedScore <= 2.999">
                  {{ 'grading.below_average' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 2 && PerceivedScore <= 2.4">
                  {{ 'grading.poor' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 1.5 && PerceivedScore <= 1.999">
                  {{ 'grading.v_poor' | translate }}
                </ng-container>
                <ng-container *ngIf="PerceivedScore >= 1 && PerceivedScore <= 1.5">
                  {{ 'grading.junk' | translate }}
                </ng-container>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="report__value my-5">
    <div class="container">
      <div class="row mx-n2">
        <div class="col-4 px-2" [class.no-print]="!marketValueChecked">
          <div class="report__valueItem d-flex justify-content-center align-items-center">
            <div class="form-check checkbox-xl no-print">
              <input
                class="form-check-input m-0 position-static"
                type="checkbox"
                [checked]="marketValueChecked"
                (change)="handleMarketValueCheck($event)"
              />
            </div>
            <div class="mx-5">
              <p class="fs fs__md mb-2">{{ 'market_value' | translate }}</p>
              {{ +ratings['market_value'] ? 'SAR ' + ratings['market_value'] : 'N/A' }}
            </div>
          </div>
        </div>
        <div class="col-4 px-2" [class.no-print]="!purchaseValueChecked">
          <div class="report__valueItem d-flex justify-content-center align-items-center">
            <div class="form-check checkbox-xl no-print">
              <input
                class="form-check-input m-0 position-static"
                type="checkbox"
                [checked]="purchaseValueChecked"
                (change)="handlePurchaseValueCheck($event)"
              />
            </div>
            <div class="mx-5">
              <p class="fs fs__md mb-2">{{ 'purchase_value' | translate }}</p>
              {{ +ratings['purchase_value'] ? 'SAR ' + ratings['purchase_value'] : 'N/A' }}
            </div>
          </div>
        </div>
        <div class="col-4 px-2" [class.no-print]="!totalRepairCostChecked">
          <div class="report__valueItem d-flex justify-content-center align-items-center">
            <div class="form-check checkbox-xl no-print">
              <input
                class="form-check-input m-0 position-static"
                type="checkbox"
                [checked]="totalRepairCostChecked"
                (change)="handleTotalRepairCostCheck($event)"
              />
            </div>
            <div class="mx-5">
              <p class="fs fs__md mb-2">
                {{ 'total_repair_cost' | translate }}
              </p>
              {{ +ratings['total_repair_cost'] ? 'SAR ' + ratings['total_repair_cost'] : 'N/A' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="report__specification mb-5">
    <div class="container">
      <div class="report__heading mb-4 mt-4">
        <h2 class="fs fs__md-high">{{ 'specs' | translate }}</h2>
      </div>

      <div class="row mx-n2">
        <div class="col-sm-6 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Year:</span>
            {{
              vinInfo['model_year_id']
                ? vinInfo['model_year_id']['value']
                  ? vinInfo['model_year_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Brand:</span>
            {{
              vinInfo['make_id']
                ? vinInfo['make_id']['value']
                  ? vinInfo['make_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Model:</span>
            {{
              vinInfo['model_id']
                ? vinInfo['model_id']['value']
                  ? vinInfo['model_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Body Type:</span>
            {{
              vinInfo['body_type_id']
                ? vinInfo['body_type_id']['value']
                  ? vinInfo['body_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Drive Type:</span>
            {{
              vinInfo['drive_type_id']
                ? vinInfo['drive_type_id']['value']
                  ? vinInfo['drive_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Engine:</span>
            {{
              vinInfo['engine_type_id']
                ? vinInfo['engine_type_id']['value']
                  ? vinInfo['engine_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Transmission:</span>
            {{
              vinInfo['transmission_type_id']
                ? vinInfo['transmission_type_id']['value']
                  ? vinInfo['transmission_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Mileage:</span>
            {{
              vinInfo['mileage_id']
                ? vinInfo['mileage_id']['value']
                  ? vinInfo['mileage_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Exterior Color:</span>
            {{
              vinInfo['exterior_color_id']
                ? vinInfo['exterior_color_id']['value']
                  ? vinInfo['exterior_color_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">RC Expiry Date:</span>
            {{
              vinInfo['estimara_expiry_date']
                ? vinInfo['estimara_expiry_date']['value']
                  ? vinInfo['estimara_expiry_date']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Trim Type:</span>
            {{
              vinInfo['trim_id']
                ? vinInfo['trim_id']['value']
                  ? vinInfo['trim_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="report__information mb-5">
    <div class="container">
      <div class="report__heading mb-4">
        <h2 class="fs fs__md-high text-capitalize">
          {{ 'nav_information' | translate }}
        </h2>
      </div>

      <div class="row mx-n2">
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.vin_number' | translate }}:</span>
            {{
              vinInfo['vin_number']
                ? vinInfo['vin_number']['value']
                  ? vinInfo['vin_number']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.plate_number' | translate }}:</span>
            {{
              vinInfo['plate_number']
                ? vinInfo['plate_number']['value']
                  ? vinInfo['plate_number']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.assessment_type' | translate }}:</span
            >
            {{
              vinInfo['assessment_type_id']
                ? vinInfo['assessment_type_id']['value']
                  ? vinInfo['assessment_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.condition' | translate }}:</span>
            {{
              vinInfo['vehicle_condition_id']
                ? vinInfo['vehicle_condition_id']['value']
                  ? vinInfo['vehicle_condition_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.engine_type' | translate }}:</span>
            {{
              vinInfo['engine_type_id']
                ? vinInfo['engine_type_id']['value']
                  ? vinInfo['engine_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.vendor' | translate }}:</span>
            {{
              vinInfo['vendor_id']
                ? vinInfo['vendor_id']['value']
                  ? vinInfo['vendor_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Origin:</span>
            {{
              vinInfo['vehicle_origin_id']
                ? vinInfo['vehicle_origin_id']['value']
                  ? vinInfo['vehicle_origin_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.fuel_type' | translate }}:</span>
            {{
              vinInfo['fuel_type_id']
                ? vinInfo['fuel_type_id']['value']
                  ? vinInfo['fuel_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.estimara' | translate }}:</span>
            {{
              vinInfo['estimara_id']
                ? vinInfo['estimara_id']['value']
                  ? vinInfo['estimara_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.make' | translate }}:</span>
            {{
              vinInfo['make_id']
                ? vinInfo['make_id']['value']
                  ? vinInfo['make_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.cc' | translate }}:</span>
            {{
              vinInfo['engine_cc_id']
                ? vinInfo['engine_cc_id']['value']
                  ? vinInfo['engine_cc_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Service and maintenance status:</span>
            {{
              vinInfo['service_maintainance']
                ? vinInfo['service_maintainance']['value']
                  ? vinInfo['service_maintainance']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.model_yr' | translate }}:</span>
            {{
              vinInfo['model_year_id']
                ? vinInfo['model_year_id']['value']
                  ? vinInfo['model_year_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.cylinders' | translate }}:</span>
            {{
              vinInfo['cyllinder_id']
                ? vinInfo['cyllinder_id']['value']
                  ? vinInfo['cyllinder_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.odo' | translate }}:</span>
            {{
              vinInfo['odo'] ? (vinInfo['odo']['value'] ? vinInfo['odo']['value'] : 'N/A') : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.model' | translate }}:</span>
            {{
              vinInfo['model_id']
                ? vinInfo['model_id']['value']
                  ? vinInfo['model_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.transmission_type' | translate }}:</span
            >
            {{
              vinInfo['transmission_type_id']
                ? vinInfo['transmission_type_id']['value']
                  ? vinInfo['transmission_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Max Speed:</span>
            {{
              vinInfo['max_speed']
                ? vinInfo['max_speed']['value']
                  ? vinInfo['max_speed']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Trim/Type:</span>
            {{
              vinInfo['trim_id']
                ? vinInfo['trim_id']['value']
                  ? vinInfo['trim_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.gear' | translate }}:</span>
            {{
              vinInfo['gear_id']
                ? vinInfo['gear_id']['value']
                  ? vinInfo['gear_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Mileage:</span>
            {{
              vinInfo['mileage_id']
                ? vinInfo['mileage_id']['value']
                  ? vinInfo['mileage_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.vehicle_type' | translate }}:</span>
            {{
              vinInfo['vehicle_type_id']
                ? vinInfo['vehicle_type_id']['value']
                  ? vinInfo['vehicle_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.seats' | translate }}:</span>
            {{
              vinInfo['seat_id']
                ? vinInfo['seat_id']['value']
                  ? vinInfo['seat_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.exterior_colour' | translate }}:</span
            >
            {{
              vinInfo['exterior_color_id']
                ? vinInfo['exterior_color_id']['value']
                  ? vinInfo['exterior_color_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.body_type' | translate }}:</span>
            {{
              vinInfo['body_type_id']
                ? vinInfo['body_type_id']['value']
                  ? vinInfo['body_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.upholstery' | translate }}:</span>
            {{
              vinInfo['uphoistery_id']
                ? vinInfo['uphoistery_id']['value']
                  ? vinInfo['uphoistery_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.interior_colour' | translate }}:</span
            >
            {{
              vinInfo['interior_color_id']
                ? vinInfo['interior_color_id']['value']
                  ? vinInfo['interior_color_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.drive_type' | translate }}:</span>
            {{
              vinInfo['drive_type_id']
                ? vinInfo['drive_type_id']['value']
                  ? vinInfo['drive_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.doors' | translate }}:</span>
            {{
              vinInfo['door_type_id']
                ? vinInfo['door_type_id']['value']
                  ? vinInfo['door_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.cod' | translate }}:</span>
            {{
              vinInfo['cod_id']
                ? vinInfo['cod_id']['value']
                  ? vinInfo['cod_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.wheel_base' | translate }}:</span>
            {{
              vinInfo['wheel_base_id']
                ? vinInfo['wheel_base_id']['value']
                  ? vinInfo['wheel_base_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Ownership:</span>
            {{
              vinInfo['ownership_id']
                ? vinInfo['ownership_id']['value']
                  ? vinInfo['ownership_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.utility_type' | translate }}:</span>
            {{
              vinInfo['utility_type_id']
                ? vinInfo['utility_type_id']['value']
                  ? vinInfo['utility_type_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">Finance Status:</span>
            {{
              vinInfo['mortage_id']
                ? vinInfo['mortage_id']['value']
                  ? vinInfo['mortage_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.warranty' | translate }}:</span>
            {{
              vinInfo['warranty_id']
                ? vinInfo['warranty_id']['value']
                  ? vinInfo['warranty_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.warranty_expiry_date' | translate }}:</span
            >
            {{
              vinInfo['warranty_expiry_date']
                ? vinInfo['warranty_expiry_date']['value']
                  ? vinInfo['warranty_expiry_date']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.last_service_date' | translate }}:</span
            >
            {{
              vinInfo['last_service_date']
                ? vinInfo['last_service_date']['value']
                  ? vinInfo['last_service_date']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.last_service_kilometers' | translate }}:</span
            >
            {{
              vinInfo['last_service_km']
                ? vinInfo['last_service_km']['value']
                  ? vinInfo['last_service_km']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.hp' | translate }}:</span>
            {{
              vinInfo['power_id']
                ? vinInfo['power_id']['value']
                  ? vinInfo['power_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.torque' | translate }}:</span>
            {{
              vinInfo['torque_id']
                ? vinInfo['torque_id']['value']
                  ? vinInfo['torque_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2">{{ 'information.acceleration' | translate }}:</span>
            {{
              vinInfo['acceleration_id']
                ? vinInfo['acceleration_id']['value']
                  ? vinInfo['acceleration_id']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.estimara_expiry_date' | translate }}:</span
            >
            {{
              vinInfo['estimara_expiry_date']
                ? vinInfo['estimara_expiry_date']['value']
                  ? vinInfo['estimara_expiry_date']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
        <div class="col-sm-6 col-md-4 mb-3 px-2">
          <p class="report__details my-0">
            <span class="font-weight-bold mr-2"
              >{{ 'information.mvpi_expiry_date' | translate }}:</span
            >
            {{
              vinInfo['mvpi_expiry_date']
                ? vinInfo['mvpi_expiry_date']['value']
                  ? vinInfo['mvpi_expiry_date']['value']
                  : 'N/A'
                : 'N/A'
            }}
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="report__option mb-5">
    <div class="container">
      <div class="report__heading mb-4">
        <h2 class="fs fs__md-high text-capitalize">
          {{ 'nav_options' | translate }}
        </h2>
      </div>

      <div class="row mx-n2">
        <div class="col-sm-4 col-md-3 mb-3 px-2" *ngFor="let option of options">
          <div class="report__details">
            <span class="font-weight-bold mr-2">
              <ng-container *ngIf="lang == 'en'">
                {{ option['title'] }}
              </ng-container>
              <ng-container *ngIf="lang == 'ar'">
                {{ option['arabic_title'] }}
              </ng-container>
            </span>
            <ul class="my-0" *ngIf="dataTypeChecker(option['data']) === 'object'">
              <li *ngFor="let item of option['data']">
                <ng-container *ngIf="lang == 'en'">
                  {{ item['title'] }}
                </ng-container>
                <ng-container *ngIf="lang == 'ar'">
                  {{ item['arabic_title'] }}
                </ng-container>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="report__flags mb-5">
    <div class="container">
      <div class="report__heading mb-4">
        <h2 class="fs fs__md-high text-capitalize">
          {{ 'nav_flags' | translate }}
        </h2>
      </div>

      <div class="row mx-n2">
        <div class="col-sm-4 col-md-3 mb-3 px-2" *ngFor="let flag of flags">
          <p class="report__details font-weight-bold text-capitalize my-0">
            {{ flag }}
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="report__ratingsection mb-5">
    <div class="container">
      <div class="report__heading mb-4">
        <h2 class="fs fs__md-high text-capitalize">
          {{ 'nav_rating' | translate }}
        </h2>
      </div>
    </div>

    <div class="report__exterior mb-5">
      <div class="container">
        <div class="report__heading2 mb-4">
          <h3 class="fs fs__md font-weight-bold my-0">Exterior</h3>
        </div>

        <div class="exterior untouchable mb-5">
          <ng-container *ngIf="main.length">
            <app-sedan
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['sedan']"
            ></app-sedan>
            <app-microbus
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['bus']"
            ></app-microbus>
            <app-truck-single-cabin
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['truckSingle']"
            ></app-truck-single-cabin>
            <app-truck-double-cabin
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['truckDouble']"
            ></app-truck-double-cabin>
            <app-suv
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['suv']"
            ></app-suv>
            <app-cargo-van
              [data]="main"
              *ngIf="vinInfo['body_type_id'].id == vehicleBodyTypes['cargo']"
            ></app-cargo-van>
          </ng-container>

          <loader [position]="{ absolute: true }" [active]="loaded"></loader>
        </div>

        <div class="pagebreak"></div>

        <div class="report__info">
          <div class="row mx-n2">
            <ng-container *ngFor="let item of ratings['exterior']">
              <div class="col-3 px-2">
                <figure class="infoCard shadow-sm">
                  <div class="infoCard__header">
                    <h3 class="fs fs__md font-weight-bold">
                      {{ item.parent_part }}
                    </h3>
                  </div>
                  <div class="infoCard__images" *ngIf="item.vpcs_old_image || item.vpcs_new_image">
                    <ng-container *ngIf="item.vpcs_old_image && item.vpcs_old_image.length">
                      <h6 class="fs fs__sm mb-1">
                        {{ 'condition_modal.before' | translate }}
                      </h6>
                      <div class="infoCard__before">
                        <ng-container *ngFor="let img of item.vpcs_old_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.vpcs_new_image && item.vpcs_new_image.length">
                      <h6 class="fs fs__sm mb-1">
                        {{ 'condition_modal.after' | translate }}
                      </h6>
                      <div class="infoCard__after mt-3">
                        <ng-container *ngFor="let img of item.vpcs_new_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <figcaption class="infoCard__caption">
                    <p class="fs fs__sm mt-0 mb-2">
                      <strong>{{ 'condition_modal.condition' | translate }}:</strong>
                      <ng-container *ngFor="let condition of item.vpcs_conditions; index as i">
                        {{ condition }}<span *ngIf="i < item.vpcs_conditions.length - 1">,</span>
                      </ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.severity' | translate }}: </strong>
                      <ng-container *ngIf="item.vpcs_severity === '1'"
                        >Part change • 1</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '2'"
                        >Major Repair • 2</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '3'"
                        >Moderate Repair • 3</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '4'"
                        >Minor Repair • 4</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '5'">Good part • 5</ng-container>
                      <ng-container *ngIf="!item.vpcs_severity">N/A</ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.labour_cost' | translate }}:</strong>
                      {{ +item.labour_cost ? 'SAR ' + item.labour_cost : 'N/A' }}
                    </p>
                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.parts_cost' | translate }}:</strong>
                      {{ +item.part_cost ? 'SAR ' + item.part_cost : 'N/A' }}
                    </p>
                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.cost_of_repair' | translate }}:</strong>
                      {{ +item.repair_cost ? 'SAR ' + item.repair_cost : 'N/A' }}
                    </p>

                    <p class="fs fs__sm">
                      <strong>{{ 'condition_modal.description' | translate }}:</strong>
                      {{ item.description || 'N/A' }}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="pagebreak"></div>

    <div class="report__interior mb-5">
      <div class="container">
        <div class="report__heading2 mb-4">
          <h3 class="fs fs__md font-weight-bold my-0">Interior</h3>
        </div>

        <div class="interior untouchable mb-5">
          <app-interior></app-interior>
        </div>

        <div class="pagebreak"></div>

        <div class="report__info">
          <div class="row mx-n2">
            <ng-container *ngFor="let item of ratings['interior']">
              <div class="col-3 px-2">
                <figure class="infoCard shadow-sm">
                  <div class="infoCard__header">
                    <h3 class="fs fs__md font-weight-bold">
                      {{ item.parent_part }}
                    </h3>
                  </div>
                  <div class="infoCard__images" *ngIf="item.vpcs_old_image || item.vpcs_new_image">
                    <ng-container *ngIf="item.vpcs_old_image && item.vpcs_old_image.length">
                      <h6 class="fs fs__sm mb-1">
                        {{ 'condition_modal.before' | translate }}
                      </h6>
                      <div class="infoCard__before">
                        <ng-container *ngFor="let img of item.vpcs_old_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.vpcs_new_image && item.vpcs_new_image.length">
                      <h6 class="fs fs__sm mb-1">
                        {{ 'condition_modal.after' | translate }}
                      </h6>
                      <div class="infoCard__after mt-3">
                        <ng-container *ngFor="let img of item.vpcs_new_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <figcaption class="infoCard__caption">
                    <p class="fs fs__sm mt-0 mb-2">
                      <strong>{{ 'condition_modal.condition' | translate }}:</strong>
                      <ng-container *ngFor="let condition of item.vpcs_conditions; index as i">
                        {{ condition }}<span *ngIf="i < item.vpcs_conditions.length - 1">,</span>
                      </ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.severity' | translate }}: </strong>
                      <ng-container *ngIf="item.vpcs_severity === '1'"
                        >Part change • 1</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '2'"
                        >Major Repair • 2</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '3'"
                        >Moderate Repair • 3</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '4'"
                        >Minor Repair • 4</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '5'">Good part • 5</ng-container>
                      <ng-container *ngIf="!item.vpcs_severity">N/A</ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.labour_cost' | translate }}:</strong>
                      {{ +item.labour_cost ? 'SAR ' + item.labour_cost : 'N/A' }}
                    </p>
                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.parts_cost' | translate }}:</strong>
                      {{ +item.part_cost ? 'SAR ' + item.part_cost : 'N/A' }}
                    </p>
                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.cost_of_repair' | translate }}:</strong>
                      {{ +item.repair_cost ? 'SAR ' + item.repair_cost : 'N/A' }}
                    </p>

                    <p class="fs fs__sm">
                      <strong>{{ 'condition_modal.description' | translate }}:</strong>
                      {{ item.description || 'N/A' }}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="pagebreak"></div>

    <div class="report__mechanics mb-5">
      <div class="container">
        <div class="report__heading2 mb-4">
          <h3 class="fs fs__md font-weight-bold my-0">Mechanics</h3>
        </div>

        <div class="mechanics untouchable mb-5">
          <app-mechanics></app-mechanics>
        </div>

        <div class="pagebreak"></div>

        <div class="report__info">
          <div class="row mx-n2">
            <ng-container *ngFor="let item of ratings['mechanics']">
              <div class="col-3 px-2">
                <figure class="infoCard shadow-sm">
                  <div class="infoCard__header">
                    <h3 class="fs fs__md font-weight-bold">
                      {{ item.parent_part }}
                    </h3>
                  </div>
                  <div class="infoCard__images" *ngIf="item.vpcs_old_image || item.vpcs_new_image">
                    <ng-container *ngIf="item.vpcs_old_image && item.vpcs_old_image.length">
                      <h6 class="fs fs__sm mb-1">
                        {{ 'condition_modal.before' | translate }}
                      </h6>
                      <div class="infoCard__before">
                        <ng-container *ngFor="let img of item.vpcs_old_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.vpcs_new_image && item.vpcs_new_image.length">
                      <h6 class="fs fs__sm mb-1">
                        {{ 'condition_modal.after' | translate }}
                      </h6>
                      <div class="infoCard__after mt-3">
                        <ng-container *ngFor="let img of item.vpcs_new_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <figcaption class="infoCard__caption">
                    <p class="fs fs__sm mt-0 mb-2">
                      <strong>{{ 'condition_modal.condition' | translate }}:</strong>
                      <ng-container *ngFor="let condition of item.vpcs_conditions; index as i">
                        {{ condition }}<span *ngIf="i < item.vpcs_conditions.length - 1">,</span>
                      </ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.severity' | translate }}: </strong>
                      <ng-container *ngIf="item.vpcs_severity === '1'"
                        >Part change • 1</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '2'"
                        >Major Repair • 2</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '3'"
                        >Moderate Repair • 3</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '4'"
                        >Minor Repair • 4</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '5'">Good part • 5</ng-container>
                      <ng-container *ngIf="!item.vpcs_severity">N/A</ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.labour_cost' | translate }}:</strong>
                      {{ +item.labour_cost ? 'SAR ' + item.labour_cost : 'N/A' }}
                    </p>
                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.parts_cost' | translate }}:</strong>
                      {{ +item.part_cost ? 'SAR ' + item.part_cost : 'N/A' }}
                    </p>
                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.cost_of_repair' | translate }}:</strong>
                      {{ +item.repair_cost ? 'SAR ' + item.repair_cost : 'N/A' }}
                    </p>

                    <p class="fs fs__sm">
                      <strong>{{ 'condition_modal.description' | translate }}:</strong>
                      {{ item.description || 'N/A' }}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="pagebreak"></div>

    <div class="report__frame mb-5">
      <div class="container">
        <div class="report__heading2 mb-4">
          <h3 class="fs fs__md font-weight-bold my-0">Frame</h3>
        </div>

        <div class="frame untouchable mb-5">
          <app-frame></app-frame>
        </div>

        <div class="pagebreak"></div>

        <div class="report__info">
          <div class="row mx-n2">
            <ng-container *ngFor="let item of ratings['frame']">
              <div class="col-3 px-2">
                <figure class="infoCard shadow-sm">
                  <div class="infoCard__header">
                    <h3 class="fs fs__md font-weight-bold">
                      {{ item.parent_part }}
                    </h3>
                  </div>
                  <div class="infoCard__images" *ngIf="item.vpcs_old_image || item.vpcs_new_image">
                    <ng-container *ngIf="item.vpcs_old_image && item.vpcs_old_image.length">
                      <h6 class="fs fs__sm mb-1">
                        {{ 'condition_modal.before' | translate }}
                      </h6>
                      <div class="infoCard__before">
                        <ng-container *ngFor="let img of item.vpcs_old_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.vpcs_new_image && item.vpcs_new_image.length">
                      <h6 class="fs fs__sm mb-1">
                        {{ 'condition_modal.after' | translate }}
                      </h6>
                      <div class="infoCard__after mt-3">
                        <ng-container *ngFor="let img of item.vpcs_new_image; index as i">
                          <div class="infoCard__thumb" [class.mr-2]="i === 0" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <figcaption class="infoCard__caption">
                    <p class="fs fs__sm mt-0 mb-2">
                      <strong>{{ 'condition_modal.condition' | translate }}:</strong>
                      <ng-container *ngFor="let condition of item.vpcs_conditions; index as i">
                        {{ condition }}<span *ngIf="i < item.vpcs_conditions.length - 1">,</span>
                      </ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.severity' | translate }}: </strong>
                      <ng-container *ngIf="item.vpcs_severity === '1'"
                        >Part change • 1</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '2'"
                        >Major Repair • 2</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '3'"
                        >Moderate Repair • 3</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '4'"
                        >Minor Repair • 4</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '5'">Good part • 5</ng-container>
                      <ng-container *ngIf="!item.vpcs_severity">N/A</ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.labour_cost' | translate }}:</strong>
                      {{ +item.labour_cost ? 'SAR ' + item.labour_cost : 'N/A' }}
                    </p>
                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.parts_cost' | translate }}:</strong>
                      {{ +item.part_cost ? 'SAR ' + item.part_cost : 'N/A' }}
                    </p>
                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.cost_of_repair' | translate }}:</strong>
                      {{ +item.repair_cost ? 'SAR ' + item.repair_cost : 'N/A' }}
                    </p>

                    <p class="fs fs__sm">
                      <strong>{{ 'condition_modal.description' | translate }}:</strong>
                      {{ item.description || 'N/A' }}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <div class="pagebreak"></div>

    <div class="report__major-options mb-5">
      <div class="container">
        <div class="report__heading2 mb-4">
          <h3 class="fs fs__md font-weight-bold my-0">Major Options</h3>
        </div>

        <div class="major-options untouchable mb-5">
          <app-major-options></app-major-options>
        </div>

        <div class="pagebreak"></div>

        <div class="report__info">
          <div class="row mx-n2">
            <ng-container *ngFor="let item of ratings['major_options']">
              <div class="col-3 px-2">
                <figure class="infoCard shadow-sm">
                  <div class="infoCard__header">
                    <h3 class="fs fs__md font-weight-bold">
                      {{ item.parent_part }}
                    </h3>
                  </div>
                  <div class="infoCard__images" *ngIf="item.vpcs_old_image || item.vpcs_new_image">
                    <ng-container *ngIf="item.vpcs_old_image && item.vpcs_old_image.length">
                      <h6 class="fs fs__sm mb-1">
                        {{ 'condition_modal.before' | translate }}
                      </h6>
                      <div class="infoCard__before">
                        <ng-container *ngFor="let img of item.vpcs_old_image; index as i">
                          <div class="infoCard__thumb" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.vpcs_new_image && item.vpcs_new_image.length">
                      <h6 class="fs fs__sm mb-1">
                        {{ 'condition_modal.after' | translate }}
                      </h6>
                      <div class="infoCard__after mt-3">
                        <ng-container *ngFor="let img of item.vpcs_new_image; index as i">
                          <div class="infoCard__thumb" *ngIf="img[i + 1]">
                            <img src="{{ item.image_url + img[i + 1] }}" width="155" height="100" />
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                  <figcaption class="infoCard__caption">
                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.condition' | translate }}:</strong>
                      <ng-container *ngFor="let condition of item.vpcs_conditions; index as i">
                        {{ condition }}<span *ngIf="i < item.vpcs_conditions.length - 1">,</span>
                      </ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.severity' | translate }}: </strong>
                      <ng-container *ngIf="item.vpcs_severity === '1'"
                        >Part change • 1</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '2'"
                        >Major Repair • 2</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '3'"
                        >Moderate Repair • 3</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '4'"
                        >Minor Repair • 4</ng-container
                      >
                      <ng-container *ngIf="item.vpcs_severity === '5'">Good part • 5</ng-container>
                      <ng-container *ngIf="!item.vpcs_severity">N/A</ng-container>
                    </p>

                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.labour_cost' | translate }}:</strong>
                      {{ +item.labour_cost ? 'SAR ' + item.labour_cost : 'N/A' }}
                    </p>
                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.parts_cost' | translate }}:</strong>
                      {{ +item.part_cost ? 'SAR ' + item.part_cost : 'N/A' }}
                    </p>
                    <p class="fs fs__sm mb-2">
                      <strong>{{ 'condition_modal.cost_of_repair' | translate }}:</strong>
                      {{ +item.repair_cost ? 'SAR ' + item.repair_cost : 'N/A' }}
                    </p>

                    <p class="fs fs__sm">
                      <strong>{{ 'condition_modal.description' | translate }}:</strong>
                      {{ item.description || 'N/A' }}
                    </p>
                  </figcaption>
                </figure>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="pagebreak"></div>

  <section class="report__gallery mb-5">
    <div class="container">
      <div class="report__heading mb-4">
        <h2 class="fs fs__md-high text-capitalize">
          {{ 'nav_gallery' | translate }}
        </h2>
      </div>
      <div class="row mx-n2">
        <div class="col-sm-3 px-2" *ngFor="let item of galleryData">
          <p class="fs fs__base mb-2" [ngSwitch]="lang">
            <ng-container *ngSwitchCase="'en'">{{ item['gallery_name'] }}</ng-container>
            <ng-container *ngSwitchCase="'ar'">{{ item['gallery_name_arabic'] }}</ng-container>
          </p>
          <div class="report__galleryThumb mb-3">
            <img src="{{ item['image'] }}" width="100" height="100" />
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="report__disclaimer mb-5">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="disclaimer">
            <h4 class="fs fs__md mb-3">Disclaimer</h4>

            <p class="fs fs__sm mb-2">
              Market Value - Estimated value may change with country , City , Condition , usage type
              etc.
            </p>
            <p class="fs fs__sm mb-2">
              Repair cost - Estimated Value will change from workshop to workshop and repair type.
            </p>
            <p class="fs fs__sm mb-2">
              Dealer Purchase Price - Estimated value will change from dealer to dealer and from
              time to time.
            </p>
            <p class="fs fs__sm mb-2">
              CV - Calculated Value is a ratio calculated by system of All good parts verses All
              defective parts which the vehicle contains, System incorporates in its calculation the
              severity of the defective part as well
            </p>
            <p class="fs fs__sm">
              PV - Perceived value of the vehicle from the selling and buying prospective under
              special conditions such as good vehicle but repainted etc. CV becomes the market value
              if PV is not available or if Numerical value of CV becomes equal or less than PV
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="report__btnGrp no-print py-3">
    <button type="button" class="btn btn-primary w-100" (click)="print()">Print</button>
  </div>
</main>

<div class="d-none" *ngIf="!isVinInfo">
  <iframe src="/vam/information" frameborder="0"></iframe>
</div>
